import styled from 'styled-components';

export const StyledPage = styled.div`
  thead th {
    color: ${({ theme }) => theme.black} !important;
    font-weight: 400 !important;
  }
`;
